module.exports = __webpack_public_path__ + "img/join-hero.6b8195da.png";